import React from 'react';

const EnvContext = React.createContext({ env: 'production', toggleEnv: () => {} });

export function EnvProvider({ children }) {
  const [env, setEnv] = React.useState(
    () => localStorage.getItem('bidsy-env') || 'production'
  );

  const toggleEnv = React.useCallback(() => {
    setEnv(prev => {
      const next = prev === 'production' ? 'development' : 'production';
      localStorage.setItem('bidsy-env', next);
      return next;
    });
  }, []);

  const value = React.useMemo(() => ({ env, toggleEnv }), [env, toggleEnv]);

  return (
    <EnvContext.Provider value={value}>
      {children}
    </EnvContext.Provider>
  );
}

export const useEnv = () => React.useContext(EnvContext);
